export default __webpack_public_path__ + "static/media/1415 cutlery side.81363604.png";